import Y from "lodash/isArrayLikeObject";
import F from "lodash/isDate";
import W from "lodash/isNumber";
import y from "lodash/isString";
const p = /d{1,2}|W{1,4}|M{1,4}|YY(?:YY)?|S{1,3}|Do|ZZ|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g, i = /\d\d?/, S = /\d{3}/, w = /\d{4}/, m = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF/]+(\s*?[\u0600-\u06FF]+){1,2}/i, H = /\[([^]*?)\]/gm, f = () => {
};
function M(e) {
  return (t, o, s) => {
    const r = s[e].indexOf(o.charAt(0).toUpperCase() + o.substr(1).toLowerCase());
    ~r && (t.month = r);
  };
}
function u(e, t) {
  for (e = String(e), t = t || 2; e.length < t; )
    e = `0${e}`;
  return e;
}
const D = {
  D(e) {
    return e.getDate();
  },
  DD(e) {
    return u(e.getDate());
  },
  Do(e, t) {
    return t.DoFn(e.getDate());
  },
  d(e) {
    return e.getDay();
  },
  dd(e) {
    return u(e.getDay());
  },
  W(e, t) {
    return t.dayNamesNarrow[e.getDay()];
  },
  WW(e, t) {
    return t.dayNamesShorter[e.getDay()];
  },
  WWW(e, t) {
    return t.dayNamesShort[e.getDay()];
  },
  WWWW(e, t) {
    return t.dayNames[e.getDay()];
  },
  M(e) {
    return e.getMonth() + 1;
  },
  MM(e) {
    return u(e.getMonth() + 1);
  },
  MMM(e, t) {
    return t.monthNamesShort[e.getMonth()];
  },
  MMMM(e, t) {
    return t.monthNames[e.getMonth()];
  },
  YY(e) {
    return String(e.getFullYear()).substr(2);
  },
  YYYY(e) {
    return u(e.getFullYear(), 4);
  },
  h(e) {
    return e.getHours() % 12 || 12;
  },
  hh(e) {
    return u(e.getHours() % 12 || 12);
  },
  H(e) {
    return e.getHours();
  },
  HH(e) {
    return u(e.getHours());
  },
  m(e) {
    return e.getMinutes();
  },
  mm(e) {
    return u(e.getMinutes());
  },
  s(e) {
    return e.getSeconds();
  },
  ss(e) {
    return u(e.getSeconds());
  },
  S(e) {
    return Math.round(e.getMilliseconds() / 100);
  },
  SS(e) {
    return u(Math.round(e.getMilliseconds() / 10), 2);
  },
  SSS(e) {
    return u(e.getMilliseconds(), 3);
  },
  a(e, t) {
    return e.getHours() < 12 ? t.amPm[0] : t.amPm[1];
  },
  A(e, t) {
    return e.getHours() < 12 ? t.amPm[0].toUpperCase() : t.amPm[1].toUpperCase();
  },
  ZZ(e) {
    const t = e.getTimezoneOffset();
    return (t > 0 ? "-" : "+") + u(Math.floor(Math.abs(t) / 60) * 100 + Math.abs(t) % 60, 4);
  }
}, n = {
  D: [
    i,
    (e, t) => {
      e.day = t;
    }
  ],
  Do: [
    new RegExp(i.source + m.source),
    (e, t) => {
      e.day = parseInt(t, 10);
    }
  ],
  d: [i, f],
  W: [m, f],
  M: [
    i,
    (e, t) => {
      e.month = t - 1;
    }
  ],
  MMM: [m, M("monthNamesShort")],
  MMMM: [m, M("monthNames")],
  YY: [
    i,
    (e, t) => {
      const s = +(/* @__PURE__ */ new Date()).getFullYear().toString().substr(0, 2);
      e.year = `${t > 68 ? s - 1 : s}${t}`;
    }
  ],
  YYYY: [
    w,
    (e, t) => {
      e.year = t;
    }
  ],
  S: [
    /\d/,
    (e, t) => {
      e.millisecond = t * 100;
    }
  ],
  SS: [
    /\d{2}/,
    (e, t) => {
      e.millisecond = t * 10;
    }
  ],
  SSS: [
    S,
    (e, t) => {
      e.millisecond = t;
    }
  ],
  h: [
    i,
    (e, t) => {
      e.hour = t;
    }
  ],
  m: [
    i,
    (e, t) => {
      e.minute = t;
    }
  ],
  s: [
    i,
    (e, t) => {
      e.second = t;
    }
  ],
  a: [
    m,
    (e, t, o) => {
      const s = t.toLowerCase();
      s === o.amPm[0] ? e.isPm = !1 : s === o.amPm[1] && (e.isPm = !0);
    }
  ],
  ZZ: [
    /([\+\-]\d\d:?\d\d|Z)/,
    (e, t) => {
      t === "Z" && (t = "+00:00");
      const o = `${t}`.match(/([+-]|\d\d)/gi);
      if (o) {
        const s = +(o[1] * 60) + parseInt(o[2], 10);
        e.timezoneOffset = o[0] === "+" ? s : -s;
      }
    }
  ]
};
n.DD = n.D;
n.dd = n.d;
n.WWWW = n.WWW = n.WW = n.W;
n.MM = n.M;
n.mm = n.m;
n.hh = n.H = n.HH = n.h;
n.ss = n.s;
n.A = n.a;
const b = (e, t, o) => {
  if (W && (e = new Date(e)), !F(e))
    throw new Error("Invalid Date in fecha.format");
  t = o.masks[t] || t;
  const s = [];
  return t = t.replace(H, (r, h) => (s.push(h), "??")), t = t.replace(
    p,
    (r) => r in D ? D[r](e, o) : r.slice(1, r.length - 1)
  ), t.replace(/\?\?/g, () => s.shift());
}, N = (e, t, o) => {
  if (typeof t != "string")
    throw new Error("Invalid mask in fecha.parse");
  if (t = o.masks[t] || t, e.length > 1e3)
    return !1;
  let s = !0;
  const r = {};
  if (t.replace(p, (a) => {
    if (n[a]) {
      const g = n[a], d = e.search(g[0]);
      ~d ? e.replace(g[0], (l) => (g[1](r, l, o), e = e.substr(d + l.length), l)) : s = !1;
    }
    return n[a] ? "" : a.slice(1, a.length - 1);
  }), !s)
    return !1;
  const h = /* @__PURE__ */ new Date();
  r.isPm === !0 && r.hour != null && +r.hour != 12 ? r.hour = +r.hour + 12 : r.isPm === !1 && +r.hour == 12 && (r.hour = 0);
  let c;
  return r.timezoneOffset != null ? (r.minute = +(r.minute || 0) - +r.timezoneOffset, c = new Date(
    Date.UTC(
      r.year || h.getFullYear(),
      r.month || 0,
      r.day || 1,
      r.hour || 0,
      r.minute || 0,
      r.second || 0,
      r.millisecond || 0
    )
  )) : c = new Date(
    r.year || h.getFullYear(),
    r.month || 0,
    r.day || 1,
    r.hour || 0,
    r.minute || 0,
    r.second || 0,
    r.millisecond || 0
  ), c;
}, x = (e, t, o) => (Y(t) && t || [y(t) && t || "YYYY-MM-DD"]).map((r) => N(e, r, o)).find((r) => r) || new Date(e);
export {
  b as format,
  x as parse
};
//# sourceMappingURL=fecha.js.map
